import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';

import Video from './views/Video';
import Snapshot from './views/Snapshot';

import './App.css';
import './styles/YoutubeEmbed.css';
import Modal from "react-bootstrap/Modal";
import CheckupModal from "./views/CheckupModal";
import capybara from './img/capybara.gif';

const App = () => {
  const [cogLoad, setCogLoad] = useState('vvl');

  const switchCL = () => {
    if (cogLoad === 'vvl') {
      setCogLoad('vvh');
    } else {
      setCogLoad('vvl');
    }
  }

  return (
    <div className="App">
      <Video cogLoad={cogLoad}/>
      <hr/>
      { cogLoad === 'vvl' && <img src={capybara}/> }
      <Snapshot setCogLoad={setCogLoad}/>
      <Button variant="primary" onClick={switchCL}>Status: {cogLoad === 'vvl' ? 'Happy' : 'Tired'}</Button>
      <CheckupModal cogLoad={cogLoad} switchCL={switchCL}/>
    </div>
  );
}

export default App;
